import PilotCopilotMessagesAPI from 'dashboard/api/pilot/copilotMessages';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'PilotCopilotMessages',
  API: PilotCopilotMessagesAPI,
  getters: {
    getMessagesByThreadId: state => copilotThreadId => {
      return state.records
        .filter(record => record.copilot_thread?.id === Number(copilotThreadId))
        .sort((a, b) => a.id - b.id);
    },
  },
  actions: mutationTypes => ({
    upsert({ commit }, data) {
      commit(mutationTypes.UPSERT, data);
    },
  }),
});
